export const userz = {
  nDmn: 1,
  nWho: 1,
};

export const grps = [
  { key: 1, pfx: '〇〇教室' },
  { key: 2, pfx: '〇〇活動推進委員会' },
  { key: 3, pfx: '〇〇研究会' },
  { key: 4, pfx: '〇〇協議会定例会' },
]

export const rooms = [
  { key: 1, pfx: '会議室1' },
  { key: 2, pfx: '会議室2' },
  { key: 3, pfx: '会議室3A' },
  { key: 4, pfx: '会議室3B' },
  { key: 5, pfx: '工芸室' },
  { key: 6, pfx: '音楽室' },
  { key: 7, pfx: '和室1' },
  { key: 8, pfx: '和室2' },
  { key: 9, pfx: '和室全室' },
  { key: 10, pfx: '広間' },
  { key: 11, pfx: '集会ホールA' },
  { key: 12, pfx: '集会ホールB' },
  { key: 13, pfx: '集会ホールC' },
  { key: 14, pfx: '集会ホールAB' },
  { key: 15, pfx: '集会ホールBC' },
  { key: 16, pfx: 'レクホール' },
  { key: 17, pfx: '全館（料理外）' },
  { key: 18, pfx: '料理' },
]

export const zones = [
  { key: 1, pfx: '午前' },
  { key: 2, pfx: '午後①' },
  { key: 3, pfx: '午後②' },
  { key: 4, pfx: '夜間' },
]

export const zone2s = [
  { key: 1, pfx: '午前①' },
  { key: 2, pfx: '午前②' },
  { key: 3, pfx: '午後①' },
  { key: 4, pfx: '午後②' },
  { key: 5, pfx: '午後③' },
  { key: 6, pfx: '夜間' },
]

export const rsvz = {
  '利用月': '2022-10',
  '利用日': '2022-10-23',
  '団体': '〇〇研究会',
  '代表者': '高橋達郎',
  '利用制限': 'なし',
  '申込者': '高橋達郎',
  '電話番号': '012-3456-7890',
  '優先利用': 'なし',
  '内容': '〇〇講演会',
  '備考': '',
  '部屋': '会議室1',
  '備品・駐車場': 'ホワイトボード',
  '内部メモ': '',
  '利用開始月': '2022-10',
  '利用終了月': '2023-09',
  '利用週': '毎月第2週',
  '利用曜日': '土',
  '利用時間帯': '午前',
  '支払期限': '2022-10-21',
  '申込日': '2022-09-27',
  '支払日': '2022-09-27',
  '支払状況': '支払済',
};

export const woms = [ // week of the month
  { key: 1, pfx: '毎月第1週' },
  { key: 2, pfx: '毎月第2週' },
  { key: 3, pfx: '毎月第3週' },
  { key: 4, pfx: '毎月第4週' },
]

export const dows = [ // day of the week
  { key: 0, pfx: '日' },
  { key: 1, pfx: '月' },
  { key: 2, pfx: '火' },
  { key: 3, pfx: '水' },
  { key: 4, pfx: '木' },
  { key: 5, pfx: '金' },
  { key: 6, pfx: '土' },
]

export const draws = [
  {
    '利用日': '2022-11-01',
    'エントリー数': 5,
    '抽選状況': '抽選済',
    '抽選日': '2022-09-15'
  },
  {
    '利用日': '2022-11-02',
    'エントリー数': 7,
    '抽選状況': '抽選済',
    '抽選日': '2022-09-15'
  },
  {
    '利用日': '2022-11-03',
    'エントリー数': 3,
    '抽選状況': '未抽選',
    '抽選日': ''
  }
];

export const fcys = [
  '山内地区センター',
  '藤が丘地区センター',
  '若草台地区センター',
  '美しが丘西地区センター',
  '奈良地区センター',
];

export const fcyz = [
  { key: 1, pfx: '山内地区センター' },
  { key: 2, pfx: '藤が丘地区センター' },
  { key: 3, pfx: '若草台地区センター' },
  { key: 4, pfx: '美しが丘西地区センター' },
  { key: 5, pfx: '奈良地区センター' },
  { key: 9, pfx: '全体' },
];

export const msg = 'メッセージ ■□■□■□■□■ ■□■□■□■□■ ■□■□■□■□■ ■□■□■□■□■ ■□■□■□■□■ ■□■□■□■□■ ■□■□■□■□■ ■□■□■□■□■ ■□■□■□■□■ ■□■□■□■□■';
